import { useLocalStorage } from '@mantine/hooks';

export function useSortingLocalStorage() {
  const [sortValues, setSortValues] = useLocalStorage<{
    linked: boolean;
    direction: 'asc' | 'desc';
    overdue: boolean;
    expanded: boolean;
    attention: boolean;
    isSample: boolean;
    isGBS: boolean;
  }>({
    key: 'sort-values',
    defaultValue: {
      isSample: false,
      linked: false,
      direction: 'desc',
      overdue: false,
      expanded: true,
      attention: false,
      isGBS: false,
    },
  });

  const toggleDirection = () => {
    setSortValues((prev) => ({
      ...prev,
      direction: prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };
  const toggleLinked = () =>
    setSortValues((prev) => ({ ...prev, linked: !prev.linked }));
  const toggleOverdue = () =>
    setSortValues((prev) => ({ ...prev, overdue: !prev.overdue }));
  const toggleExpanded = () =>
    setSortValues((prev) => ({ ...prev, expanded: !prev.expanded }));
  const toggleAttention = () =>
    setSortValues((prev) => ({ ...prev, attention: !prev.attention }));
  const toggleIsSample = () =>
    setSortValues((prev) => ({ ...prev, isSample: !prev.isSample }));
  const toggleGBS = () =>
    setSortValues((prev) => ({ ...prev, isGBS: !prev.isGBS }));

  return {
    sortValues,
    toggleLinked,
    toggleOverdue,
    toggleDirection,
    toggleExpanded,
    toggleAttention,
    toggleIsSample,
    toggleGBS,
  };
}
